export default "table thead tr th {\n  background-color: #fff !important;\n  padding-bottom: 15px;\n}"